import paginate from "jw-paginate";

const MAX_PAGES = 5;

type PaginationOptions = {
    pageSize?: number;
    onUpdate?: (hasCurrentPageChanged?: boolean) => void;
}
//
// type AjaxListPaginationType = 'load-more-btn' | 'pagination';

export default class Pagination {
    state: {
        totalItems: number;
        currentPage: number;
        pageSize: number;
        totalPages: number;
        startPage: number;
        endPage: number;
        startIndex: number;
        endIndex: number;
        pages: number[];
    };

    onUpdate: (hasCurrentPageChanged?: boolean) => void;

    constructor(options?: PaginationOptions) {
        this.state = paginate(0, 1, options?.pageSize, MAX_PAGES);
        this.onUpdate = options?.onUpdate ?? (() => {});
    }

    goToPage(page: number): void {
        let hasCurrentPageChanged = false;

        if (this.state.currentPage !== page) {
            this.state.currentPage = page;
            hasCurrentPageChanged = true;

            // Add page parameter to URL
            const url = new URL(window.location.href);
            url.searchParams.set("page", page.toString());
            window.history.pushState({}, "", url.toString());

            // Set page cookie for back button
            const uri = window.location.href;
            if (!uri.includes('wohnungssuche') && !uri.includes('apartment-search')) {
                const expirationDate = new Date();
                expirationDate.setTime(expirationDate.getTime() + (12 * 60 * 60 * 1000));
                const expires = "expires=" + expirationDate.toUTCString();
                document.cookie = 'property_list_page=' + page.toString() + '; ' + expires + '; path=/';
            } else {
                document.cookie = 'property_list_page=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
            }
        }

        this.update(hasCurrentPageChanged);
    }

    setTotalItems(totalItems: number): void {
        this.state.totalItems = totalItems;
    }

    update(hasCurrentPageChanged = false): void {
        this.state = paginate(this.state.totalItems, this.state.currentPage, this.state.pageSize, MAX_PAGES);
        this.onUpdate(hasCurrentPageChanged);
    }
}
